import styled from "styled-components";

export const MenuBoardContainer = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PreviewContainer = styled.div`
  &.contain {
    .company img {
      object-fit: contain;
    }
  }
  .company {
    .mySwiper {
      width: 100%;
      aspect-ratio: 2 / 1;
    }
    .box {
      width: 100%;
      height: 100%;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      margin-bottom: 10px;
    }
    p {
      padding: 10px 20px;
      font-size: 22px;
      font-weight: 800;
    }
  }
  .tags {
    display: flex;
    justify-content: center;
    gap: 10px;
    flex-wrap: wrap;
    font-size: 12px;
    margin-bottom: 10px;
    strong {
      font-weight: 700;
      background: #f2aa27;
      color: #fff;
      padding: 6px 16px;
      border-radius: 14px;
      font-size: 12px;
    }
    span {
      padding: 6px 16px;
      border-radius: 14px;
      &.cmpnySe {
        background: #f2aa27;
        color: #fff;
      }
      &.badge {
        font-weight: 700;
        color: #f06e96;
        background: rgba(240, 110, 150, 0.2);
        &:nth-child(3) {
          color: #42ad7a;
          background: rgba(66, 173, 122, 0.2);
        }
      }
    }
  }
`;

export const MenuBoardDetails = styled.div`
  padding: 20px;
  font-size: 14px;
  .section {
    margin-bottom: 30px;
    &:last-child {
      margin-bottom: 0;
    }
    h3 {
      font-size: 18px;
      font-weight: 700;
      margin-bottom: 10px;
    }
    p {
      white-space: pre-line;
    }
  }
`;

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  letter-spacing: -1px;
  position: relative;
  > div {
    width: 100%;
    max-width: 500px;
    height: 100%;
    max-height: 700px;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
    margin: auto;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
  }
  .content {
    height: calc(100% - 50px);
    overflow-y: auto;
  }
  .hd {
    display: flex;
    align-items: center;
    height: 50px;
    position: relative;
    border-bottom: 1px solid #ebebeb;
    button {
      font-size: 28px;
      background: transparent;
      border: none;
      svg {
        display: block;
        margin: auto;
      }
    }
    p {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      font-size: 20px;
      font-weight: 700;
    }
  }
  button.submit {
    width: 100%;
    height: 50px;
    background: #f2aa27;
    color: #fff;
    font-size: 18px;
    font-weight: 700;
    border: none;
    z-index: 10px;
  }
  @media screen and (max-width: 767px) {
    > div {
      width: 100%;
      box-shadow: none;
      height: 100%;
      margin: 0 auto;
    }
  }
`;

export const MenuContainer = styled.div`
  .slideWrapper {
    height: auto;
    min-height: calc(100% - 284px);
    .slideContent {
      width: 100%;
      transition: transform 0.3s ease;
    }
    .slideContent.inactive {
      position: absolute;
      opacity: 0;
      z-index: -1;
      pointer-events: none;
      display: none;
    }
    .slideContent.active {
      position: relative;
      opacity: 1;
      z-index: 1;
    }
  }
  .category {
    font-size: 16px;
    font-weight: 700;
    overflow-x: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
    ul {
      display: flex;
      align-items: center;
      padding: 0 20px;
      gap: 20px;
      height: 50px;
      border-bottom: 1px solid #ebebeb;
      min-width: 100%;
      width: max-content;
      li {
        cursor: pointer;
      }
    }
  }
  .menuGroup {
    min-height: 200px;
    > li {
      padding: 30px 20px;
      p {
        font-size: 20px;
        font-weight: 700;
        margin-bottom: 20px;
      }
      ul {
        font-size: 16px;
        li {
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          gap: 20px;
          cursor: pointer;
          &.soldout img {
            filter: grayscale(100%);
          }
          &.soldout .status,
          &.low .status {
            color: #555;
            background: #eee;
          }
          &.available .status {
            color: rgb(255, 88, 88);
            background: rgba(255, 88, 88, 0.2);
          }
          img {
            width: 100px;
            height: 100px;
            border-radius: 50%;
            border: 1px solid #ccc;
          }
          span {
            display: block;
            &.status {
              width: fit-content;
              padding: 1px 5px;
              font-size: 13px;
              margin-bottom: 5px;
              border-radius: 2px;
            }
            &.shortDescription {
              color: #b1b1b1;
              font-size: 14px;
            }
            &.name,
            &.price {
              font-weight: 700;
            }
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
  .images {
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    font-size: 16px;
    img {
      width: calc(50% - 10px);
      aspect-ratio: 1;
      border: 1px solid #ccc;
      object-fit: cover;
      border-radius: 10px;
    }
  }
  p.text {
    padding: 20px;
    font-size: 16px;
  }
  .submit {
    position: sticky;
    bottom: -1px;
    left: 0;
    z-index: 10;
  }
  @media screen and (max-width: 767px) {
    .menuGroup > li {
      padding: 20px;
      ul li {
        gap: 10px;
        font-size: 14px;
        span.status {
          font-size: 12px;
          margin-bottom: 4px;
        }
        .productInfo {
          width: calc(100% - 90px);
        }
        img {
          width: 80px;
          height: 80px;
        }
      }
    }
    .category {
      font-size: 14px;
    }
  }
`;

export const MenuBoardTabMenu = styled.ul`
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #d0962d;
  font-size: 16px;
  display: flex;
  float: none;
  gap: 20px;
  background: #fff;
  &.center {
    justify-content: center;
  }
  li {
    padding: 0 20px;
    font-weight: 700;
    text-align: center;
    cursor: pointer;
    &.active {
      border-bottom: 2px solid #d0962d;
    }
  }
  @media screen and (max-width: 767px) {
    font-size: 14px;
  }
`;

export const MenuBoardStoreInfo = styled.div`
  padding: 20px;
  strong {
    font-weight: 700;
    background: #f2aa27;
    color: #fff;
    padding: 6px 16px;
    border-radius: 14px;
    font-size: 12px;
    width: 80px;
    text-align: center;
  }
  div {
    display: flex;
    align-items: center;
    gap: 30px;
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    .cont {
      font-weight: normal;
      font-size: 16px;
      width: calc(100% - 110px);
    }
    span {
      display: block;
    }
  }
`;

export const ProductContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  background: #fff;
  overflow-y: auto;
  &.inactive {
    width: 0;
    overflow: hidden;
  }
  > button:nth-child(1) {
    font-size: 28px;
    background: transparent;
    border: none;
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 5;
    svg {
      display: block;
      margin: auto;
    }
  }
  p.price {
    font-size: 24px;
    font-weight: 700;
    padding: 0 20px 10px;
    border-bottom: 1px solid #ebebeb;
  }
  .options {
    > li {
      font-size: 16px;
      border-bottom: 1px solid #ebebeb;
      padding: 20px;
      &:last-child {
      }
    }
    .option {
      > div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        p {
          strong {
            font-size: 18px;
            font-weight: 700;
            display: block;
          }
          span {
            font-size: 14px;
            color: #555;
          }
        }
        .tag {
          font-size: 12px;
          padding: 5px 10px;
          border-radius: 15px;
          &.required {
            background: rgba(240, 110, 150, 0.2);
            color: #f06e96;
          }
          &.optional {
            background: rgba(66, 173, 122, 0.2);
            color: #42ad7a;
          }
        }
      }
      ul {
        margin-bottom: 20px;
        li {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
          &:last-child {
            margin-bottom: 0;
          }
          label {
            display: flex;
            align-items: center;
            gap: 10px;
            cursor: pointer;
            input {
              display: none;
              &:checked {
                + span.checkmark {
                  background: #f2aa27;
                }
              }
            }
            span.checkmark {
              display: block;
              width: 16px;
              height: 16px;
              border-radius: 50%;
              background: #ededed;
              position: relative;
            }
            span.checkmark::after {
              content: "";
              display: block;
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background: #fff;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
            span.optionName {
              font-size: 14px;
              color: #555;
            }
            ~ span {
              font-size: 12px;
            }
          }
        }
      }
    }
  }
  .action {
    padding: 20px;
    border-bottom: 1px solid #ebebeb;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .buttons {
      display: flex;
      align-items: center;
      span {
        font-size: 18px;
        width: 60px;
        text-align: center;
      }
      button {
        width: 30px;
        height: 30px;
        border: none;
        background: transparent;
        font-size: 20px;
      }
    }
    .total {
      display: flex;
      align-items: center;
      gap: 10px;
      span {
        font-size: 14px;
        color: #555;
        &:last-child {
          font-size: 18px;
          font-weight: 700;
        }
      }
    }
    .desc {
      font-size: 14px;
    }
  }
`;

export const CartContainer = styled.div`
  .st {
    font-size: 18px;
    font-weight: 700;
    height: 50px;
    line-height: 50px;
    padding: 0 20px;
    border-bottom: 1px solid #ebebeb;
    display: block;
  }
`;

export const EditOptionContainer = styled.div`
  width: 100%;
  height: 100%;
  font-size: 16px;
  ul {
    height: calc(100% - 50px);
    li {
      padding: 10px 20px;
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }
      .tit {
        font-size: 20px;
        font-weight: 700;
        margin-bottom: 5px;
      }
      select {
        width: 100%;
        height: 30px;
        border: 1px solid #ebebeb;
        border-radius: 5px;
        padding: 0 10px;
        font-size: 14px;
        &:focus {
          outline: none;
          border: 1px solid #ebebeb !important;
          box-shadow: none;
        }
      }
    }
  }
`;

export const CompanyContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
  img {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    object-fit: cover;
  }
  span {
    font-size: 18px;
    font-weight: 700;
  }
`;

export const CartListContainer = styled.ul`
  height: calc(100% - 150px);
  overflow-y: auto;
  .it {
    margin-bottom: 10px;
    position: relative;
    padding: 10px 30px 10px 20px;
    gap: 10px;
    display: flex;
    font-size: 14px;
    border-bottom: 1px solid #ebebeb;
  }
  .rm {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 20px;
    background: transparent;
    border: none;
    svg {
      display: block;
      margin: auto;
    }
  }
  .img img {
    width: 70px;
    height: 70px;
    object-fit: contain;
    border-radius: 50%;
  }
  .ct {
    gap: 10px;
    width: calc(100% - 80px);
    font-size: 14px;
  }
  .nm {
    font-size: 16px;
    margin-bottom: 5px;
    display: block;
  }
  .opt {
    margin: 5px 0;
    color: #555;
    display: block;
  }
  .optBtn {
    display: block;
    margin: 5px 0;
    background: #ebebeb;
    border: none;
    width: 70px;
    border-radius: 5px;
    height: 24px;
  }
  .meta {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .qty {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .qtyBtn {
    width: 24px;
    height: 24px;
    border: none;
    background: transparent;
    font-size: 16px;
  }
  .qtyVal {
    min-width: 24px;
    text-align: center;
    display: inline-block;
  }
  .price {
    font-weight: 700;
  }
`;

export const OrderContainer = styled.div`
  .content {
    > div {
      height: calc(100% - 50px);
      padding: 20px;
    }
    .payment-method {
      margin-bottom: 10px;
    }
    .payment-store {
      margin-top: 10px;
    }
    .payment-method button,
    .payment-store button {
      font-weight: 700;
      font-size: 15px;
      font-weight: 300;
      width: calc(100% / 4 - 6px);
      border-radius: 4px;
      line-height: 56px;
      text-align: center;
      height: 56px;
      background-color: rgb(255, 255, 255);
      border: 1px solid rgb(229, 232, 235);
      color: rgb(78, 89, 104);
      cursor: pointer;
      margin-top: 20px;
      margin-right: 10px;
      &.active {
        background-color: rgb(255, 255, 255);
        border: 1px solid rgb(25, 31, 40);
        font-weight: 700;
        color: rgb(25, 31, 40);
      }
    }
  }
  @media screen and (max-width: 767px) {
    .content {
      > div {
        padding: 0;
      }
    }
  }
`;

export const OrderResultContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  flex-direction: column;
  height: 100vh;
  gap: 10px;
  strong {
    color: #f2aa27;
  }
  button {
    width: 200px;
    height: 50px;
    background: #f2aa27;
    color: #fff;
    font-size: 18px;
    font-weight: 700;
    border: none;
    border-radius: 5px;
  }
`;
